import { Category } from '../models/category.model';
import { BaseService } from '../../../../core/services/base.service';

export class CategoryService {
  static async GetCategories(): Promise<Category[]> {
    try {
      const url = BaseService.BuildUrl(`/public/jobs/categories`);
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(
          `Categories request failed: ${response.status} ${response.statusText}`
        );
      }

      const json = await response.json();

      return json as Category[];
    } catch (error: unknown) {
      const message =
        error instanceof Error
          ? error.message
          : 'Unknown error loading categories';
      throw new Error(message);
    }
  }

  static async GetSubCategories(): Promise<string[]> {
    try {
      const url = BaseService.BuildUrl(`/public/jobs/sub-categories`);

      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }

      let json = await response.json();

      return json as string[];
    } catch (error: any) {
      throw new Error(error.message);
    }
  }
}
